
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FinancialDisclosure from "../pages/financial-disclosure/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/financial-disclosure",
    element: <FinancialDisclosure />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
